<template>
	<V id="monitoring"/>
</template>
<script>
export default {};
</script>
